



















/* Created- 15 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { ArticleKeyword, IArticle } from "../../../Models/ArticleModels/article";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
@Component(
	{
		name: "ArticleKeywords"
	})
export default class ArticleKeywords extends Vue {
	@Prop() private value: IArticle;
	private newKeyword: string = "";

	private remove(item: ArticleKeyword) {
		if (this.value.removeKeyword(item) === -1) {
			throw new Error("Unable to remove keyword as its not found.");
		}
	}
	private addKeyword() {
		if (this.newKeyword.length > 0) {
			this.value.addKeyword(this.newKeyword);
			this.newKeyword = "";
			this.$emit("partica-event", { action: eParticaAction.PROPERTY_CHANGED } as ParticaEvent);
			// remove focus from input as drop dont work if still focussed.
			(this.$refs.kw as any).blur();
		}
	}
}
